"use client";

import React from "react";
import SubPageLayout from "@/components/common/SubPageLayout";
import DiagramSection from "@/components/diagrams/DiagramSection";
import DiagramCard from "@/components/diagrams/DiagramCard";
import TwillDutchDiagram from "@/components/diagrams/TwillDutchDiagram";
import { useLanguage } from "@/hooks/useLanguage";
import { pick } from "@/lib/i18n";
import { COPY } from "./content";
const diagramCopy = {
  sectionTitle: {
    en: "Twill Dutch Weave Micro-Geometry",
    zh: "斜纹荷兰编织微观几何构造",
    es: "Microgeometría del Tejido Twill Dutch",
    de: "Mikrogeometrie der Köpertresse",
    fr: "Microgéométrie du Tissage Reps Sergé",
    pt: "Microgeometria da Trama Holandesa Sarjada"
  },
  sectionLead: {
    en: "Visualizing the 2/2 twilled interlacing where compacted fine shute wires pack double density, creating microscopic curved pore channels.",
    zh: "直观展示 2/2 斜纹交织结构，细纬丝实现双倍密集重叠堆积，构建出曲折立体的微米级过滤孔隙通道。",
    es: "Visualización del ligamento en sarga 2/2 donde los alambres finos de trama se empaquetan a doble densidad.",
    de: "Darstellung der 2/2-Köperbindung mit doppelter Schussdichte zur Bildung gewundener mikroskopischer Porenkanäle.",
    fr: "Visualisation de l'armure sergée 2/2 permettant une double densité de fils de trame et des canaux micrométriques courbes.",
    pt: "Visualização do entrelaçamento em sarja 2/2 onde os fios finos de trama dobram de densidade, formando microporos curvos."
  },
  cardTitle: {
    en: "2/2 Twilled Dutch Wire Arrangement",
    zh: "2/2 斜纹荷兰双丝致密排列",
    es: "Disposición de Alambres Twill Dutch 2/2",
    de: "2/2 Köpertresse Drahtanordnung",
    fr: "Disposition des Fils Reps Sergé 2/2",
    pt: "Disposição de Fios Holandesa Sarjada 2/2"
  },
  cardDesc: {
    en: "The stepped 2/2 twill progression accommodates dense double-weft packing, blocking direct line of sight and delivering calibrated retention down to 1 µm.",
    zh: "阶梯式 2/2 斜纹走线容纳致密双层细纬丝，完全消除直通透光并稳定实现低至 1 微米精密截留。",
    es: "La progresión en sarga 2/2 acomoda una trama doble compacta, bloqueando el paso directo de luz y asegurando retención de hasta 1 µm.",
    de: "Die versetzte 2/2-Köperbindung ermöglicht dichte Doppelschusslagen ohne Direktdurchsicht für Filtration bis 1 µm.",
    fr: "La progression sergée 2/2 accueille une double trame dense, supprimant la vue directe pour une rétention dès 1 µm.",
    pt: "A progressão em sarja 2/2 permite acomodar trama dupla compacta, bloqueando a luz direta e garantindo retenção de até 1 µm."
  }
};
export default function TwillDutchWeavePage() {
  const {
    lang
  } = useLanguage();
  const content = pick(lang, COPY);
  const diagram = <DiagramSection id="diagram" title={pick(lang, diagramCopy.sectionTitle)} lead={pick(lang, diagramCopy.sectionLead)} tone="background">
      <div className="max-w-3xl mx-auto">
        <DiagramCard index="02" badge="ISO 9044 / ASTM E2016" title={pick(lang, diagramCopy.cardTitle)} description={pick(lang, diagramCopy.cardDesc)}>
          <TwillDutchDiagram />
        </DiagramCard>
      </div>
    </DiagramSection>;
  return <SubPageLayout content={content} diagram={diagram} />;
}